module.exports = __webpack_public_path__ + "static/media/default-free-resource.8028ed1a.jpg";